import {getPaddedNumber} from './PadNumber';

const DAY = 1440;
export const timestampUIPattern = '[0-2][0-9]:[0-5][0-9]';
export const  timeStampUIRegex: RegExp = new RegExp(timestampUIPattern);
const databaseTimestampFormatRegex = new RegExp('-?[0-9]{2}:[0-5][0-9]');

export function getTimeStampDisplayFormat(timeStamp: string): TimeStampDisplayFormat {
  // check to make sure the format from the backend is correct. If it isn't don't try to parse it.
  if (!timeStamp || !databaseTimestampFormatRegex.test(timeStamp))
    return { time: '', plusOne: false, minusOne: false };

  const minutes = convertTimestampToMinutes(timeStamp);

  if (isNegativeTime(timeStamp)) {
    if (minutes === 0)
      return {time: convertMinutesToTimestamp(0), plusOne: false, minusOne: false};
    return {time: convertMinutesToTimestamp(DAY - minutes), plusOne: false, minusOne: true};
  }


  if (minutes >= DAY)
    return {time: convertMinutesToTimestamp(minutes % 1440), plusOne: true, minusOne: false };
  return {time: timeStamp, plusOne: false, minusOne: false }
}

export interface TimeStampDisplayFormat {
  time: string;
  plusOne: boolean;
  minusOne: boolean;
}

export function getTimeStampValueFormat(timeStamp: string, plusOne: boolean, minusOne: boolean): string {
  let minutes = convertTimestampToMinutes(timeStamp);
  if (minusOne) {
    const remaining = DAY - minutes;
    return '-' + convertMinutesToTimestamp(remaining);
  }

  if (plusOne)
    minutes += 1440;
    return convertMinutesToTimestamp(minutes);
}


function convertMinutesToTimestamp(minutes: number): string {
  const newHours = Math.floor(minutes / 60);
  let newMinutes = 0;
  if (newHours === 0)
    newMinutes = minutes;
  else
    newMinutes = minutes % (newHours * 60);
  return getPaddedNumber(newHours) + ':' + getPaddedNumber(newMinutes);
}

function convertTimestampToMinutes(timestamp: string): number {
  const parts = timestamp.split(':');
  const initialHours = Math.abs(Number.parseInt(parts[0]));
  const initialMinutes = Number(parts[1]);
  return (initialHours * 60) + initialMinutes;
}

function isNegativeTime(timestamp: string): boolean {
  return timestamp.split(':')[0].indexOf('-') !== -1
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/timestamp-field/time-stamp-formatter.ts